<template>
  <div class="eu-mb_5">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ title }}
    </p>
    <router-link
      v-if="showCustomersDetail"
      :to="{ name: 'customersDetail', params }"
      class="emd-link fs-hide"
    >
      <slot></slot>
    </router-link>
    <p
      v-else
      class="emd-text fs-hide"
    >
      <slot name="fallback"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodCustomersDetailLink',

  props: {
    title: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    customerId: { required: true },
    merchantId: { required: true },
    accountId: { required: true }
  },

  computed: {
    params () {
      return {
        merchant_id: this.merchantId,
        account_id: this.accountId,
        id: this.customerId,
        tab: this.tabName
      }
    },
    showCustomersDetail () {
      return this.permissionIsEnabled('customer:get')
    }
  },

  methods: {
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  }
}
</script>
